export const AgentTools = {
  ImageAdsAgent: {
    AskAspectRatio: "ask-image-ad-aspect-ratio",
    VerifyImageAdsAssets: "verify-image-ad-image-assets",
    GenerateConcepts: "generate-image-ads-concepts",
    GenerateImageAds: "generate-image-ads",
    GenerateImageAdsVariations: "generate-image-ads-variations",
    CloneImageAds: "clone-image-ads",
    ResizeImageAds: "resize-image-ads",
    EditImageAds: "edit-image-ads",
  },
  AnimatedAdsAgent: {
    AskDuration: "ask-animated-ad-duration",
    AskAspectRatio: "ask-animated-ad-aspect-ratio",
    VerifyAnimatedAdsAssets: "verify-animated-ad-image-assets",
    GenerateConcepts: "generate-animated-ads-concepts",
    GenerateAnimatedAdsFromConcepts: "generate-animated-ads-from-concepts",
    GenerateAnimatedAdsFromImages: "generate-animated-ads-from-images",
    ChangeAnimatedAdsAudio: "change-animated-ads-audio",
    ResizeAnimatedAds: "resize-animated-ads",
    EditAnimatedAds: "edit-animated-ads",
    GenerateAnimatedAdsVariations: "generate-animated-ads-variations",
  },
  VideoAdsAgent: {
    AskDuration: "ask-video-ad-duration",
    AskAspectRatio: "ask-video-ad-aspect-ratio",
    VerifyVideoAdsAssets: "verify-video-ad-image-assets",
    GenerateConceptBriefs: "generate-video-ad-concept-briefs",
    SelectConceptBriefs: "select-video-ad-concept-brief",
    GenerateConcepts: "generate-video-ads-concepts",
    GenerateVideoAds: "generate-video-ads",
    EditVideoAds: "edit-video-ads",
    CloneVideoAds: "clone-video-ads-concept",
  },
  ExtendedVideoAdsAgent: {
    AskDuration: "ask-extended-video-ad-duration",
    AskAspectRatio: "ask-extended-video-ad-aspect-ratio",
    VerifyVideoAdsAssets: "verify-extended-video-ad-image-assets",
    GenerateConceptBriefs: "generate-extended-video-ad-concept-briefs",
    SelectConceptBriefs: "select-extended-video-ad-concept-brief",
    GenerateVideoAdsConcepts: "generate-extended-video-ad-concept",
    GenerateVideoAds: "generate-extended-video-ad",
    EditVideoAds: "edit-extended-video-ads",
  },
  UGCAgent: {
    AskDuration: "ask-ugc-marketing-video-duration",
    AskAspectRatio: "ask-ugc-marketing-video-aspect-ratio",
    AskCategory: "ask-ugc-marketing-video-category",
    VerifyUGCAssets: "verify-ugc-marketing-video-image-assets",
    GenerateConceptBriefs: "generate-ugc-marketing-concept-briefs",
    SelectConceptBriefs: "select-ugc-marketing-concept-brief",
    GenerateConcepts: "generate-ugc-marketing-videos-concepts",
    GenerateUGCMarketingVideos: "generate-ugc-marketing-videos",
    EditUGCMarketingVideos: "edit-ugc-marketing-videos",
    CloneUGCMarketingVideos: "clone-ugc-marketing-videos-concept",
  },
  ExtendedUGCAgent: {
    AskAspectRatio: "ask-extended-ugc-video-aspect-ratio",
    AskCategory: "ask-extended-ugc-video-category",
    VerifyExtendedUGCAssets: "verify-extended-ugc-video-ad-image-assets",
    GenerateConceptBriefs: "generate-extended-ugc-video-concept-briefs",
    SelectConceptBrief: "select-extended-ugc-video-concept-brief",
    GenerateExtendedUGCConcepts: "generate-extended-ugc-video-concepts",
    GenerateExtendedUGCVideo: "generate-extended-ugc-videos",
  },
  Veo3Agent: {
    CreateVideo: "create-veo3-video",
  },
  ProductAvatarAgent: {
    VerifyAssets: "verify-avatar-image-assets",
    SelectAvatar: "select-product-avatar",
    ProductPlacement: "avatar-product-placement",
    EditVoice: "edit-product-avatar-voice",
    SelectCaption: "select-product-avatar-caption",
    GenerateScript: "generate-product-avatar-script",
    VerifyScript: "verify-product-avatar-script",
    GenerateVideo: "generate-product-avatar-video",
  },
  BrandResearch: {
    ResearchBrandInformation: "research-brand-information",
    ResearchBrandPerformance: "research-brand-performance",
    ResearchTargetAudience: "research-target-audience",
    ResearchCompetitorAnalysis: "research-competitor-analysis",
    ResearchBrandCreativeGuidelines: "research-brand-creative-guidelines",
  },
  Common: {
    ScrapeURL: "scrape-url",
    SearchWeb: "search-web",
    SelectICP: "select-icp",
    GenerateICPs: "generate-icps",
    AnalyseImages: "analyse-images",
    AskClarifyingQuestions: "ask-clarifying-questions",
    PlanNextSteps: "plan-next-steps",
    SelectVideoCaption: "select-video-caption",
    SelectProductCatalogue: "select-product-catalogue",
    RetrieveProductInformation: "retrieve-product-information",
    GenerateQuickChoices: "generate-quick-choices",
    RetrieveBrandCreativeGuidelines: "retrieve-brand-creative-guidelines",
  },
  Fallback: {
    AnimatedAdsV1: {
      GenerateAnimatedAdsFromConcepts: "generate-video-ads-from-concepts",
      GenerateAnimatedAdsFromImages: "generate-video-ads-from-images",
      ChangeAnimatedAdsAudio: "change-video-ads-audio",
      ResizeAnimatedAds: "resize-generated-video-ads",
      EditAnimatedAds: "edit-generated-video-ads",
      GenerateAnimatedAdsVariations: "generate-video-ads-variations",
    },
  },
};

export const AgentToolReasoning = {
  /**
   * Common Tools
   */
  [AgentTools.Common.ScrapeURL]: {
    start: "Gathering information from url",
    end: "Gathered information from url",
  },
  [AgentTools.Common.SearchWeb]: {
    start: "Searching the web for information",
    end: "Searched the web for information",
  },
  [AgentTools.Common.RetrieveProductInformation]: {
    start: "Retrieving product information",
    end: "Retrieved product information",
  },
  [AgentTools.Common.SelectProductCatalogue]: {
    start: "Select a product from the catalogue",
    end: "Selected a product from the catalogue",
  },
  [AgentTools.Common.RetrieveBrandCreativeGuidelines]: {
    start: "Retrieving brand creative guidelines",
    end: "Retrieved brand creative guidelines",
  },
  [AgentTools.Common.GenerateICPs]: {
    start: "Searching for the ideal customer profiles",
    end: "Found the ideal customer profiles",
  },
  [AgentTools.Common.SelectICP]: {
    start: "Select an ideal customer profile",
    end: "Selected an ideal customer profile",
  },
  [AgentTools.Common.AnalyseImages]: {
    start: "Analysing the images",
    end: "Analysed the images",
  },
  [AgentTools.Common.AskClarifyingQuestions]: {
    start: "Asking clarifying questions",
    end: "Asked clarifying questions",
  },
  [AgentTools.Common.PlanNextSteps]: {
    start: "Planning the next steps",
    end: "Planned the next steps",
  },
  [AgentTools.Common.SelectVideoCaption]: {
    start: "Select the style of captions",
    end: "Selected the style of captions",
  },

  /**
   * End of Common Tools
   */

  /**
   * Image Ads Agent
   */
  [AgentTools.ImageAdsAgent.VerifyImageAdsAssets]: {
    start: "Verify the image assets",
    end: "Verified the image assets",
  },
  [AgentTools.ImageAdsAgent.AskAspectRatio]: {
    start: "Clarify the format of the ads",
    end: "Clarified the format of the ads",
  },
  [AgentTools.ImageAdsAgent.GenerateConcepts]: {
    start: "Generating concept ideas for ads",
    end: "Generated concept ideas for ads",
  },
  [AgentTools.ImageAdsAgent.GenerateImageAds]: {
    start: "Generating polished image ads",
    end: "Generated polished image ads",
  },
  [AgentTools.ImageAdsAgent.EditImageAds]: {
    start: "Editing the image ads",
    end: "Edited the image ads",
  },
  [AgentTools.ImageAdsAgent.ResizeImageAds]: {
    start: "Resizing image ads",
    end: "Resized image ads",
  },
  [AgentTools.ImageAdsAgent.GenerateImageAdsVariations]: {
    start: "Generating variations of the image ads",
    end: "Generated variations of the image ads",
  },
  [AgentTools.ImageAdsAgent.CloneImageAds]: {
    start: "Cloning the image ads",
    end: "Cloned the image ads",
  },
  /**
   * End of Image Ads Agent
   */

  /**
   * Animated Ads Agent
   */
  [AgentTools.AnimatedAdsAgent.AskDuration]: {
    start: "Clarify the duration of the ads",
    end: "Clarified the duration of the ads",
  },
  [AgentTools.AnimatedAdsAgent.AskAspectRatio]: {
    start: "Clarify the format of the ads",
    end: "Clarified the format of the ads",
  },
  [AgentTools.AnimatedAdsAgent.VerifyAnimatedAdsAssets]: {
    start: "Verify the image assets for ads",
    end: "Verified the image assets for ads",
  },
  [AgentTools.AnimatedAdsAgent.GenerateConcepts]: {
    start: "Generating concept ideas for ads",
    end: "Generated concept ideas for ads",
  },
  [AgentTools.AnimatedAdsAgent.GenerateAnimatedAdsFromConcepts]: {
    start: "Generating polished animated ads",
    end: "Generated polished animated ads",
  },
  [AgentTools.AnimatedAdsAgent.GenerateAnimatedAdsFromImages]: {
    start: "Converting images into animated ads",
    end: "Converted images into animated ads",
  },
  [AgentTools.AnimatedAdsAgent.ResizeAnimatedAds]: {
    start: "Resizing the animated ads",
    end: "Resized the animated ads",
  },
  [AgentTools.AnimatedAdsAgent.EditAnimatedAds]: {
    start: "Editing the animated ads",
    end: "Edited the animated ads",
  },
  [AgentTools.AnimatedAdsAgent.GenerateAnimatedAdsVariations]: {
    start: "Generating variations of the animated ads",
    end: "Generated variations of the animated ads",
  },
  [AgentTools.AnimatedAdsAgent.ChangeAnimatedAdsAudio]: {
    start: "Selecting a new audio for the animated ad",
    end: "Selected a new audio for the animated ad",
  },
  /**
   * End of Animated Ads Agent
   */

  /**
   * Video Ads Agent
   */
  [AgentTools.VideoAdsAgent.AskDuration]: {
    start: "Clarify the duration of the ads",
    end: "Clarified the duration of the ads",
  },
  [AgentTools.VideoAdsAgent.AskAspectRatio]: {
    start: "Clarify the format of the ads",
    end: "Clarified the format of the ads",
  },
  [AgentTools.VideoAdsAgent.VerifyVideoAdsAssets]: {
    start: "Verify the image assets for ads",
    end: "Verified the image assets for ads",
  },
  [AgentTools.VideoAdsAgent.GenerateConceptBriefs]: {
    start: "Generating creative briefs for ads",
    end: "Generated creative briefs for ads",
  },
  [AgentTools.VideoAdsAgent.SelectConceptBriefs]: {
    start: "Select the creative brief",
    end: "Selected the creative brief",
  },
  [AgentTools.VideoAdsAgent.GenerateConcepts]: {
    start: "Generating concept ideas for ads",
    end: "Generated concept ideas for ads",
  },
  [AgentTools.VideoAdsAgent.GenerateVideoAds]: {
    start: "Generating polished video ads",
    end: "Generated polished video ads",
  },
  [AgentTools.VideoAdsAgent.EditVideoAds]: {
    start: "Editing the video ads",
    end: "Edited the video ads",
  },
  [AgentTools.VideoAdsAgent.CloneVideoAds]: {
    start: "Cloning the video ads",
    end: "Cloned the video ads",
  },
  /**
   * End of Video Ads Agent
   */

  /**
   * Extended Video Ads Agent
   */
  [AgentTools.ExtendedVideoAdsAgent.AskDuration]: {
    start: "Clarify the duration of the ads",
    end: "Clarified the duration of the ads",
  },
  [AgentTools.ExtendedVideoAdsAgent.AskAspectRatio]: {
    start: "Clarify the format of the ads",
    end: "Clarified the format of the ads",
  },
  [AgentTools.ExtendedVideoAdsAgent.VerifyVideoAdsAssets]: {
    start: "Verify the image assets for ads",
    end: "Verified the image assets for ads",
  },
  [AgentTools.ExtendedVideoAdsAgent.GenerateConceptBriefs]: {
    start: "Generating creative briefs for ads",
    end: "Generated creative briefs for ads",
  },
  [AgentTools.ExtendedVideoAdsAgent.SelectConceptBriefs]: {
    start: "Select the creative brief",
    end: "Selected the creative brief",
  },
  [AgentTools.ExtendedVideoAdsAgent.GenerateVideoAdsConcepts]: {
    start: "Generating concept ideas for ads",
    end: "Generated concept ideas for ads",
  },
  [AgentTools.ExtendedVideoAdsAgent.GenerateVideoAds]: {
    start: "Generating polished video ads",
    end: "Generated polished video ads",
  },
  [AgentTools.ExtendedVideoAdsAgent.EditVideoAds]: {
    start: "Editing the video ads",
    end: "Edited the video ads",
  },
  /**
   * End of Extended Video Ads Agent
   */

  /**
   * Extended UGC Video Agent
   */
  [AgentTools.ExtendedUGCAgent.AskAspectRatio]: {
    start: "Clarify the format of the UGC video",
    end: "Clarified the format of the UGC video",
  },
  [AgentTools.ExtendedUGCAgent.AskCategory]: {
    start: "Clarify the category of the UGC video",
    end: "Clarified the category of the UGC video",
  },
  [AgentTools.ExtendedUGCAgent.VerifyExtendedUGCAssets]: {
    start: "Verify the image assets for the UGC video",
    end: "Verified the image assets for the UGC video",
  },
  [AgentTools.ExtendedUGCAgent.GenerateConceptBriefs]: {
    start: "Generating creative briefs for the UGC video",
    end: "Generated creative briefs for the UGC video",
  },
  [AgentTools.ExtendedUGCAgent.SelectConceptBrief]: {
    start: "Select the UGC video creative brief",
    end: "Selected the UGC video creative brief",
  },
  [AgentTools.ExtendedUGCAgent.GenerateExtendedUGCConcepts]: {
    start: "Generating polished UGC video concepts",
    end: "Generated polished UGC video concepts",
  },
  [AgentTools.ExtendedUGCAgent.GenerateExtendedUGCVideo]: {
    start: "Generating polished UGC videos",
    end: "Generated polished UGC videos",
  },

  /**
   * End of Extended UGC Video Agent
   */

  /**
   * UGC Video Agent
   */
  [AgentTools.UGCAgent.AskDuration]: {
    start: "Clarifying the duration of the UGC video",
    end: "Clarified the duration of the UGC video",
  },
  [AgentTools.UGCAgent.AskAspectRatio]: {
    start: "Clarifying the platform and format of the UGC video",
    end: "Clarified the platform and format of the UGC video",
  },
  [AgentTools.UGCAgent.AskCategory]: {
    start: "Clarifying the category of the UGC video",
    end: "Clarified the category of the UGC video",
  },
  [AgentTools.UGCAgent.VerifyUGCAssets]: {
    start: "Verify the image assets for the UGC video",
    end: "Verified the image assets for the UGC video",
  },
  [AgentTools.UGCAgent.GenerateConceptBriefs]: {
    start: "Generating creative briefs for the UGC video",
    end: "Generated creative briefs for the UGC video",
  },
  [AgentTools.UGCAgent.SelectConceptBriefs]: {
    start: "Select the creative brief",
    end: "Selected the creative brief",
  },
  [AgentTools.UGCAgent.GenerateConcepts]: {
    start: "Generating concept ideas for the UGC video",
    end: "Generated concept ideas for the UGC video",
  },
  [AgentTools.UGCAgent.GenerateUGCMarketingVideos]: {
    start: "Generating the UGC marketing videos",
    end: "Generated the UGC marketing videos",
  },
  [AgentTools.UGCAgent.EditUGCMarketingVideos]: {
    start: "Editing the UGC marketing videos",
    end: "Edited the UGC marketing videos",
  },

  /**
   * End of UGC Video Agent
   */

  /**
   * Avatar Video Agent
   */
  [AgentTools.ProductAvatarAgent.VerifyAssets]: {
    start: "Select the product images for the video",
    end: "Selected the product images for the video",
  },
  [AgentTools.ProductAvatarAgent.SelectAvatar]: {
    start: "Select avatar for the video",
    end: "Selected avatar for the video",
  },
  [AgentTools.ProductAvatarAgent.ProductPlacement]: {
    start: "Select the placement of the product in the video",
    end: "Selected the placement in the video",
  },
  [AgentTools.ProductAvatarAgent.EditVoice]: {
    start: "Select new voice for the video",
    end: "Selected new voice for the video",
  },
  [AgentTools.ProductAvatarAgent.SelectCaption]: {
    start: "Select the caption style for the video",
    end: "Selected the caption style for the video",
  },
  [AgentTools.ProductAvatarAgent.GenerateScript]: {
    start: "Generating the script for the video",
    end: "Generated the script for the video",
  },
  [AgentTools.ProductAvatarAgent.VerifyScript]: {
    start: "Verify the script for the video",
    end: "Verified the script for the video",
  },
  [AgentTools.ProductAvatarAgent.GenerateVideo]: {
    start: "Generating the product avatar video",
    end: "Generated the product avatar video",
  },
  /**
   * End of Product Avatar Agent
   */

  /**
   * Veo 3 Agent
   */
  [AgentTools.Veo3Agent.CreateVideo]: {
    start: "Generating your stunning video",
    end: "Generated your stunning video",
  },
  /**
   * End of Veo 3 Agent
   */

  /**
   * Brand Research Agent
   */
  [AgentTools.BrandResearch.ResearchBrandInformation]: {
    start: "Gathering information about the brand",
    end: "Gathered information about the brand",
  },
  [AgentTools.BrandResearch.ResearchBrandPerformance]: {
    start: "Analyzing the brand's performance",
    end: "Analyzed the brand's performance",
  },
  [AgentTools.BrandResearch.ResearchBrandCreativeGuidelines]: {
    start: "Analyzing your brand's creative guidelines",
    end: "Analyzed your brand's creative guidelines",
  },
  [AgentTools.BrandResearch.ResearchTargetAudience]: {
    start: "Gathering information about your ideal audiences",
    end: "Gathered information about your ideal audiences",
  },
  [AgentTools.BrandResearch.ResearchCompetitorAnalysis]: {
    start: "Gathering information about your competitors",
    end: "Gathered information about your competitors",
  },
  /**
   * End of Brand Research Agent
   */

  /**
   * Fallback Agent Tool Reasoning
   */
  [AgentTools.Fallback.AnimatedAdsV1.GenerateAnimatedAdsFromConcepts]: {
    start: "Generating animated ads from concepts",
    end: "Generated animated ads from concepts",
  },
  [AgentTools.Fallback.AnimatedAdsV1.GenerateAnimatedAdsFromImages]: {
    start: "Generating animated ads from images",
    end: "Generated animated ads from images",
  },
  [AgentTools.Fallback.AnimatedAdsV1.ChangeAnimatedAdsAudio]: {
    start: "Changing the audio of the animated ads",
    end: "Changed the audio of the animated ads",
  },
  [AgentTools.Fallback.AnimatedAdsV1.ResizeAnimatedAds]: {
    start: "Resizing the animated ads",
    end: "Resized the animated ads",
  },
  [AgentTools.Fallback.AnimatedAdsV1.EditAnimatedAds]: {
    start: "Editing the animated ads",
    end: "Edited the animated ads",
  },
  [AgentTools.Fallback.AnimatedAdsV1.GenerateAnimatedAdsVariations]: {
    start: "Generating variations of the animated ads",
    end: "Generated variations of the animated ads",
  },
  Fallback: {
    start: "Processing the next step",
    end: "Processed the next step",
  },
  /**
   * End of Fallback Agent Tool Reasoning
   */
};

export const AgentViewportTools = [
  /*
  Image Ads Agent
  */
  AgentTools.ImageAdsAgent.GenerateImageAds,
  AgentTools.ImageAdsAgent.GenerateImageAdsVariations,
  AgentTools.ImageAdsAgent.ResizeImageAds,
  AgentTools.ImageAdsAgent.EditImageAds,
  AgentTools.ImageAdsAgent.CloneImageAds,

  /*
  Animated Ads Agent
  */
  AgentTools.AnimatedAdsAgent.GenerateAnimatedAdsFromConcepts,
  AgentTools.AnimatedAdsAgent.GenerateAnimatedAdsFromImages,
  AgentTools.AnimatedAdsAgent.GenerateAnimatedAdsVariations,
  AgentTools.AnimatedAdsAgent.ChangeAnimatedAdsAudio,
  AgentTools.AnimatedAdsAgent.ResizeAnimatedAds,
  AgentTools.AnimatedAdsAgent.EditAnimatedAds,

  /*
  Video Ads Agent
  */
  AgentTools.VideoAdsAgent.GenerateVideoAds,
  AgentTools.VideoAdsAgent.EditVideoAds,

  /*
  Extended Video Ads Agent
  */
  AgentTools.ExtendedVideoAdsAgent.GenerateVideoAds,
  AgentTools.ExtendedVideoAdsAgent.EditVideoAds,

  /*
  UGC Video Agent
  */
  AgentTools.UGCAgent.GenerateUGCMarketingVideos,
  AgentTools.UGCAgent.EditUGCMarketingVideos,

  /*
  Extended UGC Video Agent
  */
  AgentTools.ExtendedUGCAgent.GenerateExtendedUGCVideo,

  /*
  Product Avatar Agent
  */
  AgentTools.ProductAvatarAgent.GenerateVideo,

  /*
  Veo 3 Agent
  */
  AgentTools.Veo3Agent.CreateVideo,

  /*
  Fallback Agent
  */
  AgentTools.Fallback.AnimatedAdsV1.GenerateAnimatedAdsFromConcepts,
  AgentTools.Fallback.AnimatedAdsV1.GenerateAnimatedAdsFromImages,
  AgentTools.Fallback.AnimatedAdsV1.ChangeAnimatedAdsAudio,
  AgentTools.Fallback.AnimatedAdsV1.ResizeAnimatedAds,
  AgentTools.Fallback.AnimatedAdsV1.EditAnimatedAds,
  AgentTools.Fallback.AnimatedAdsV1.GenerateAnimatedAdsVariations,
];

export const AgentIgnoreTools = [
  /**
   * Common Tools
   */
  AgentTools.Common.GenerateQuickChoices,
];

export const AgentHiddenTools = [
  /**
   * Product Avatar Agent
   */
  AgentTools.ProductAvatarAgent.SelectAvatar,
  AgentTools.ProductAvatarAgent.ProductPlacement,
  AgentTools.ProductAvatarAgent.EditVoice,
  AgentTools.ProductAvatarAgent.VerifyAssets,
  /**
   * Video Ads Agent
   */
  AgentTools.VideoAdsAgent.VerifyVideoAdsAssets,
  AgentTools.VideoAdsAgent.AskAspectRatio,
  /**
   * Extended Video Ads Agent
   */
  AgentTools.ExtendedVideoAdsAgent.VerifyVideoAdsAssets,
  AgentTools.ExtendedVideoAdsAgent.AskAspectRatio,
  /**
   * Image Ads Agent
   */
  AgentTools.ImageAdsAgent.VerifyImageAdsAssets,
  AgentTools.ImageAdsAgent.AskAspectRatio,
  /**
   * Animated Ads Agent
   */
  AgentTools.AnimatedAdsAgent.VerifyAnimatedAdsAssets,
  AgentTools.AnimatedAdsAgent.AskAspectRatio,
  /**
   * UGC Video Agent
   */
  AgentTools.UGCAgent.AskCategory,
  AgentTools.UGCAgent.VerifyUGCAssets,
  AgentTools.UGCAgent.AskAspectRatio,
  /**
   * Extended UGC Video Agent
   */
  AgentTools.ExtendedUGCAgent.VerifyExtendedUGCAssets,
  AgentTools.ExtendedUGCAgent.AskAspectRatio,
  AgentTools.ExtendedUGCAgent.AskCategory,
];
